<template>
  <div class="cig-table">
    <div class="header-btn" :style="{minHeight: $slots.header ? '32px' : 'auto'}">
      <div class="button-group">
        <el-button
          v-if="showAction && !actionConfig.notAdd"
          :icon="IconAdd"
          type="primary"
          @click="add"
          >{{ t('el.cigTable.added') }}</el-button
        >
        <el-button
          v-if="showSelection && showAction && !actionConfig.notAllDel"
          type="danger"
          :disabled="!selectioned.length"
          @click="allDel(selectioned)"
          >{{ t('el.cigTable.removeAll') }}</el-button
        >
        <slot name="header" />
      </div>
      <div v-if="showColumn && mode !== 'inline'" class="button-group">
        <el-column-popover
          ref="popoverRef"
          :mode="mode"
          :show-index="showIndex"
          :show-selection="showSelection"
          :data="columns"
          v-model:checkbox="checkboxVal"
          @ok="onCheckboxOk"
          @cancel="onCheckboxCancel"
        ></el-column-popover>
      </div>
    </div>
    <el-table
      ref="tableRefName"
      v-bind="{
        ...tableOption,
        stripe,
        border,
        onSelectionChange,
        onSelect,
        onSelectAll,
      }"
    >
      <el-table-column
        v-if="selectionStatus"
        type="selection"
        :width="55"
        :selectable="selectable"
        :reserve-selection="reserveSelection"
      />
      <el-table-column
        v-if="indexStatus"
        type="index"
        :width="showMode ? 100 : 80"
        :label="t('el.cigTable.index')"
      >
        <template #header>
          <div class="el-column-setting">
            {{ t('el.cigTable.index') }}
          </div>
          <template
            v-if="!actionConfig.showAction && showMode && mode === 'inline'"
          >
            <el-column-popover
              ref="popoverRef"
              :mode="mode"
              :show-index="showIndex"
              :show-selection="showSelection"
              :data="columns"
              v-model:checkbox="checkboxVal"
              @ok="onCheckboxOk"
              @cancel="onCheckboxCancel"
            ></el-column-popover>
          </template>
        </template>
      </el-table-column>
      <template v-for="(item, index) in columns" :key="item[idKey]">
        <el-table-column
          v-if="!item.display"
          v-bind="item"
          :class-name="'cell-tooltip-text ' + (item.className || '')"
          :show-overflow-tooltip="false"
          :customTooltip="item.showOverflowTooltip"
        >
          <template #header>
            <div class="el-column-setting">
              {{ item.label }}
            </div>
            <template
              v-if="
                !actionConfig.showAction &&
                popoverIndex === index &&
                mode === 'inline'
              "
            >
              <el-column-popover
                ref="popoverRef"
                :mode="mode"
                :show-index="showIndex"
                :show-selection="showSelection"
                :data="columns"
                v-model:checkbox="checkboxVal"
                @ok="onCheckboxOk"
                @cancel="onCheckboxCancel"
              ></el-column-popover>
            </template>
          </template>
          <template #default="{ row, column, $index }">
            <slot
              v-if="item.type === 'slot'"
              :name="item.prop"
              :row="row"
              :column="item"
              :index="$index"
            />

            <template v-else>
              <el-column-tooitlp
                :pageSize="pageConfig.pageSize"
                :showOverflowTooltip="item.showOverflowTooltip"
                :tooltipWidth="item.tooltipWidth"
                :data="{ row, column, $index, placeholder }"
              ></el-column-tooitlp>
            </template>
          </template>
        </el-table-column>
      </template>
      <slot />
      <el-table-column
        v-if="actionConfig.showAction && !actionConfig.notAction"
        :label="t('el.cigTable.action')"
        v-bind="actionConfig.attribute"
      >
        <template #header>
          <div class="el-column-setting">
            {{ t('el.cigTable.action') }}
          </div>
          <template v-if="mode === 'inline'">
            <el-column-popover
              ref="popoverRef"
              :mode="mode"
              :show-index="showIndex"
              :show-selection="showSelection"
              :data="columns"
              v-model:checkbox="checkboxVal"
              @ok="onCheckboxOk"
              @cancel="onCheckboxCancel"
            ></el-column-popover>
          </template>
        </template>
        <template #default="{ column, row, $index }">
          <div class="action-button-group">
            <el-button
              v-if="!actionConfig.notView"
              size="small"
              @click="view({ column, row, $index })"
              >{{ t('el.cigTable.view') }}</el-button
            >
            <el-button
              v-if="!actionConfig.notEdit"
              size="small"
              @click="edit({ column, row, $index })"
              >{{ t('el.cigTable.edit') }}</el-button
            >
            <el-button
              v-if="!actionConfig.notDel"
              type="danger"
              size="small"
              @click="del({ column, row, $index })"
              >{{ t('el.cigTable.delete') }}</el-button
            >
            <slot name="action" :row="row" :column="column" :index="$index" />
          </div>
        </template>
      </el-table-column>
      <template #append>
        <slot name="append" />
      </template>
      <template #empty>
        <div class="cig-table-empty">
          <div class="cig-table-empty-icon">
            <el-icon :size="160">
              <IconNotData />
            </el-icon>
            <div class="el-table-empty-text">
              {{ t('el.table.emptyText') }}
            </div>
          </div>
        </div>
      </template>
    </el-table>
    <div v-if="showPage" class="csi-table-footer">
      <div class="selection">
        <el-button v-if="showSelection" @click="unCheck">
          {{ t('el.cigTable.uncheck') }}
        </el-button>
        <span v-if="showSelection" class="check">
          {{
            t('el.cigTable.selectionTotal', {
              selectionTotal,
              total,
            })
          }}
        </span>
      </div>
      <div class="csi-page">
        <el-pagination
          ref="pageRefName"
          v-bind="pageConfig"
          v-model:current-page="pageConfig.currentPage"
          v-model:page-size="pageConfig.pageSize"
        >
          <template #default>
            <span class="total">
              {{
                t('el.pagination.total', {
                  total,
                })
              }}
            </span>
          </template>
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import {
  computed,
  defineComponent,
  getCurrentInstance,
  nextTick,
  onDeactivated,
  reactive,
  ref,
  toRaw,
  watch,
} from 'vue'
import { isNumber } from 'lodash-unified'
import { useLocale } from '@park-ui/hooks'
import { IconAdd } from '@park-ui/components/cig-icon'
import defaultProps, {
  ActionEmits,
  components,
  getRealLabel,
  initSelection,
  tableEmits,
} from './table'
import { defaultRenderCell } from '@park-ui/components/table/src/config'
import type { TablePropType } from './table'

export default defineComponent({
  name: 'ElCigTable',
  components,
  props: defaultProps,
  emits: tableEmits,
  setup(props, { emit, expose }) {
    const { t } = useLocale()
    const instance = getCurrentInstance()
    const pageConfig = reactive({
      currentPage: 1,
      pageSize: 10,
      total: 0,
      layout: 'total,sizes,prev,pager,next,jumper',
      onCurrentChange: (current: number) => {
        emit('current-page', current)
      },
      onSizeChange: (sizes: number) => {
        emit('size-change', sizes)
      },
      ...props.pageOption,
    })
    const {
      selectionList,
      tableRefName,
      pageRefName,
      onSelectionChange,
      onSelect,
      onSelectAll,
      clearSelection,
      findSelection,
      clearAllSelection,
    } = initSelection(instance!)
    const { stripe = false, border = true } = instance!.props
      .tableOption as unknown as TablePropType<any>
    const selectioned = computed(() => selectionList)
    const selectionTotal = computed(() => selectionList.length)
    // 与页码关联的序号
    const pageIndex = (index: number) => {
      return toRaw(
        ((props.pageOption.currentPage || 1) - 1) *
          (props.pageOption.pageSize || 10) +
          index +
          1
      )
    }
    const actionConfig = computed<any>(() => {
      const actionOption = props.actionOption
      return {
        showAction: true,
        attribute: {},
        ...actionOption,
      }
    })
    const showAction = actionConfig.value.showAction
    // 默认列表操作项
    const { view, edit, del, add, allDel } = ActionEmits(instance!)
    // 取消选中
    const unCheck = () => {
      clearAllSelection()
      emit('un-checked')
    }
    watch(
      () => props.pageOption.total,
      () => {
        pageConfig.total = props.pageOption.total || 0
      }
    )
    watch(
      () => props.pageOption.currentPage,
      () => {
        pageConfig.currentPage = props.pageOption.currentPage || 1
      }
    )
    watch(
      () => props.pageOption.pageSize,
      () => {
        pageConfig.pageSize = props.pageOption.pageSize || 10
      }
    )
    watch(
      () => props.tableOption.data,
      () => {
        console.log(props.tableOption.data)
        // 存在多选 判断是否回填选中
        if (selectionList && selectionList.length > 0) {
          nextTick(() => {
            props.tableOption.data!.forEach((x) => {
              const row = findSelection(selectionList, x)
              tableRefName.value.toggleRowSelection(x, Boolean(row))
            })
          })
        }
      },
      {
        deep: true,
      }
    )

    const showMode = ref(false)
    const popoverIndex = computed(() => {
      const list = props.columns.filter((x) => !x.display)
      const row = list[list.length - 1]
      const rowIndex = props.columns.findIndex((x) => x.prop === row.prop)
      return rowIndex
    })

    const indexStatus = ref(props.showIndex)
    const selectionStatus = ref(props.showSelection)
    expose({
      selectionList: selectioned,
      tableRef: tableRefName,
      pageRef: pageRefName,
      clearAllSelection,
    })
    // 列表项控制
    const checkboxVal = ref<any>([])
    const onCheckboxOk = () => {
      props.columns.forEach((x) => {
        x.display = !checkboxVal.value.includes(x.prop)
      })
      indexStatus.value = checkboxVal.value.includes('index')
      selectionStatus.value = checkboxVal.value.includes('selection')
      if (checkboxVal.value.length <= 2) {
        const checkList = props.columns.filter((x) => !x.display)
        showMode.value =
          checkList.length === 0 && checkboxVal.value.includes('index')
      } else {
        showMode.value = false
      }
    }
    const onCheckboxCancel = () => {
      checkboxVal.value =
        props.columns.filter((x) => !x.display).map((x) => x.prop) || []
      if (indexStatus.value) checkboxVal.value.push('index')
      if (selectionStatus.value) checkboxVal.value.push('selection')
    }
    watch(
      () => props.columns,
      (newV) => {
        const newColumns =
          newV.filter((x) => !x.display).map((x) => x.prop) || []
        checkboxVal.value = newColumns
        if (indexStatus.value) checkboxVal.value.push('index')
        if (selectionStatus.value) checkboxVal.value.push('selection')
      },
      {
        immediate: true,
        deep: true,
      }
    )
    // 占位符
    const placeholder = computed(() => props.placeholder)
    //ref="popoverRef"
    const popoverRef = ref()

    onDeactivated(() => {
      popoverRef.value.popoverVisible && popoverRef.value.hide()
    })

    return {
      t,
      tableRefName, // 列表实例
      pageRefName, // 分页实例
      selectioned, // 选中数据
      stripe, // 是否开启斑马纹
      border, // 默认显示外边框
      showAction,
      pageConfig,
      selectionTotal,
      actionConfig,
      unCheck,
      getRealLabel,
      placeholder,
      onSelectionChange,
      onSelect,
      onSelectAll,
      clearSelection,
      findSelection,
      pageIndex,
      view,
      edit,
      del,
      add,
      allDel,
      total: pageConfig.total,
      IconAdd,
      popoverIndex,
      indexStatus,
      selectionStatus,
      showMode,
      checkboxVal,
      onCheckboxOk,
      onCheckboxCancel,
      isNumber,
      defaultRenderCell,
    }
  },
})
</script>
